// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import AddressResourceViewModel from '../../../../viewModel/resource/AddressResourceViewModel';
import AddressValidationResourceViewModel from '../../../../viewModel/resource/AddressValidationResourceViewModel';
import AddressValidationResourceDTO from '../../dto/resource/AddressValidationResourceDTO';

export default abstract class AddressValidationResourceModel extends BaseModel<AddressValidationResourceDTO> {
  /**
  */
  get addresses() { return this.getArrayModels(() => this.dto.addresses, AddressResourceViewModel)!; }
  set addresses(value) { this.setArrayModels(() => this.dto.addresses, value); }
  /**
  */
  get isCountrySupported() { return this.dto.isCountrySupported; }
  set isCountrySupported(value) { this.dto.isCountrySupported = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = qs.isCountrySupported === 'true' ? true : qs.iscountrysupported;
    value = qs.isCountrySupported === 'false' ? false : undefined;
    this.dto.isCountrySupported = value;
  }
}
